export default __webpack_public_path__ + "img/logo_giglifepro_white-931e80eb7f4aadb1db8785cb6d50bba1.png";